import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["height", "width"];
import React from 'react';

var CheckedIcon = function CheckedIcon(_ref) {
  var height = _ref.height,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: height,
    width: width,
    viewBox: "0 0 16 16",
    version: "1.1"
  }, props, {
    "data-qa": "checked-icon"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "16",
    height: "16",
    rx: "2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5, 4.5)",
    fill: "white",
    stroke: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checkboxCheckV",
    d: "M7.20941606,0.302675939 L3.2580362,5.37896024 L1.7805388,3.97437186 C1.58845087,3.7866272 1.32708824,3.67954231 1.05223568,3.67954231 C0.777156115,3.67954231 0.515518336,3.78681173 0.318855013,3.97961102 C-0.106126962,4.39556691 -0.106331564,5.07583706 0.318520822,5.49231005 L2.57899788,7.70794788 C2.7718423,7.89659292 3.03855706,7.99996024 3.31373575,7.99996024 C3.5617431,7.99996024 3.79922206,7.91792107 3.98506344,7.76257443 L4.05741809,7.68802569 L8.7247841,1.75285802 C9.10598806,1.38371161 9.10598806,0.703955326 8.68204543,0.287729847 C8.31850739,-0.0682754093 7.68531834,-0.0975867459 7.29047301,0.220271465 L7.20941606,0.302675939 Z"
  }))));
};

export default CheckedIcon;